<mat-form-field appearance="fill" style="margin-top: -23px;">    
        <span matSuffix *ngIf="isCellValue" (click)="clearText()"><i  class="fas fa-times"></i></span>                   
        <input class="customFont" [(ngModel)]="cellValue" (click)="openDRGSelector()" (keydown)="false" [disabled]="isdisabled"  matInput>
</mat-form-field>